module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Picker-33ca28234e3373c23ac5e3ce8a07b6db05481c9789b1db2f70381eb2b8a877bf.svg";